import { ChangeDetectionStrategy, Component, Input, computed, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CATG } from '@shared/utils/category.util';

/**
 * Colored category pill (mockup `.apill`). Pass a service-category `code` (label + color
 * resolved from CATG) or explicit `label` + `color`.
 */
@Component({
  selector: 'app-category-pill',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './category-pill.component.html',
  
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CategoryPillComponent {
  private readonly _code = signal('');
  private readonly _label = signal('');
  private readonly _color = signal('');

  @Input() set code(v: string) { this._code.set(v ?? ''); }
  @Input() set label(v: string) { this._label.set(v ?? ''); }
  @Input() set color(v: string) { this._color.set(v ?? ''); }

  readonly resolvedLabel = computed(() =>
    this._label() || CATG[this._code()]?.label || this._code());
  readonly resolvedColor = computed(() =>
    this._color() || CATG[this._code()]?.color || '#5E747A');
  /** Light tint background from the 6-digit hex color (append low alpha). */
  readonly bg = computed(() => {
    const c = this.resolvedColor();
    return /^#[0-9a-fA-F]{6}$/.test(c) ? `${c}1f` : 'var(--mint)';
  });
}
